import { createFileRoute } from "@tanstack/react-router";
import { DailySalesVerify } from "@/features/reports/daily-sales-verify";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/weryfikacja-sprzedazy/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.weryfikacja-sprzedazy",
			location.pathname,
		);
	},
	component: DailySalesVerify,
});
